import { render, staticRenderFns } from "./MusicPlaylistHeader.vue?vue&type=template&id=b85a6100&"
import script from "./MusicPlaylistHeader.vue?vue&type=script&lang=js&"
export * from "./MusicPlaylistHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports